import { crv, cva } from '@/styled-system/css';

export const paginationItemStyles = cva({
  base: {
    '&:has(>.c11n_pagination__page-button)': {
      marginInlineStart: 'tightest',
    },
    '&:has(>.c11n_pagination__ellipsis)': {
      marginInlineStart: 'Pagination.Item.between-pages',
    },
    '.c11n_pagination__item:has(>.c11n_pagination__previous-button) + &': {
      marginInlineStart: '0',
    },
    '&:has(>.c11n_pagination__previous-button)': {
      paddingInline: 'tighter',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
      marginInlineEnd: 'micro.default',
    },
    '&:has(>.c11n_pagination__next-button)': {
      paddingInline: 'tighter',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
      marginInlineStart: 'micro.default',
    },
    '&:has(>.c11n_pagination__jump-to-first-button)': {
      paddingInline: 'Pagination.JumpItem.padding.horz',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
    },
    '&:has(>.c11n_pagination__jump-to-last-button)': {
      paddingInline: 'Pagination.JumpItem.padding.horz',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
    },
  },
  variants: {
    ...crv('showNumberButtons', {
      true: {
        '&:has(>.c11n_pagination__page-button)': {
          display: 'inline-flex',
        },
        '&:has(>.c11n_pagination__ellipsis)': {
          display: 'inline-flex',
        },
        '&:has(>.c11n_pagination__jump-to-first-button)': {
          display: 'none',
        },
        '&:has(>.c11n_pagination__jump-to-last-button)': {
          display: 'none',
        },
      },
      false: {
        '&:has(>.c11n_pagination__page-button)': {
          display: 'none',
        },
        '&:has(>.c11n_pagination__ellipsis)': {
          display: 'none',
        },
        '&:has(>.c11n_pagination__previous-button)': {
          paddingInline: 0,
        },
        '&:has(>.c11n_pagination__next-button)': {
          paddingInline: 0,
        },
        '&:has(>.c11n_pagination__jump-to-first-button)': {
          display: 'inline-flex',
          paddingInline: 0,
        },
        '&:has(>.c11n_pagination__jump-to-last-button)': {
          display: 'inline-flex',
          paddingInline: 0,
        },
      },
    }),
  },
});
